import React, {useState} from 'react';
import ContactUsImage from '../../assest/contact.png'
import './contactus.scss'

const ContactUs = () => {
	
	const [formData, setFormData] = useState({
		name: "",
		email: "",
		message: ""
	});
	
	const handleChange = (e) => {
		setFormData({
			...formData,
			[e.target.name]: e.target.value
		});
	};
	
	const handleSubmit = async (e) => {
		e.preventDefault();
		
		// Replace with your Google Form's submission URL (changed viewform to formResponse)
		const GOOGLE_FORM_URL = "https://docs.google.com/forms/d/e/1FAIpQLSc9AmWlhV0IL81lCX7doUPP3tUq5LUE2ioiNVrrnEWQRZolCQ/formResponse";
		
		// Replace with the actual entry IDs from your Google Form
		const entryIds = {
			name: "entry.281355402", // Example ID, get from inspecting your form
			email: "entry.998383805", // Example ID
			message: "entry.1466531283" // Example ID
		};
		
		const dataToSend = new FormData();
		dataToSend.append(entryIds.name, formData.name);
		dataToSend.append(entryIds.email, formData.email);
		dataToSend.append(entryIds.message, formData.message);
		
		try {
			const response = await fetch(GOOGLE_FORM_URL, {
				method: 'POST',
				mode: 'no-cors', // Important for cross-origin requests to Google Forms
				body: dataToSend,
			});
			
			// Since mode is 'no-cors', we won't get a readable response,
			// but if there's no error, we can assume it went through.
			console.log("Form submitted to Google Form!", response);
			alert("Your message has been sent successfully!");
			setFormData({ name: "", email: "", message: "" }); // Clear form
			
		} catch (error) {
			console.error("Error submitting form to Google Form:", error);
			alert("There was an error sending your message. Please try again.");
		}
	};
	
	return (
		<>
			<div id="contact" className="mainContactUs">
				<div className="subContactUs">
					<div className="LeftImage">
						<img src={ContactUsImage} alt=""/>
					</div>
					<form onSubmit={handleSubmit}>
						<h2>Contact us</h2>
						<div className="Contactus-Input">
							<label htmlFor="name">Name</label>
							<input
								type="text"
								id="name"
								name="name"
								value={formData.name}
								onChange={handleChange}
							/>
						</div>
						<div className="Contactus-Input">
							<label htmlFor="email">Email address</label>
							<input
								type="email"
								id="email"
								name="email"
								value={formData.email}
								onChange={handleChange}
							/>
						</div>
						<div className="Contactus-Input">
							<label htmlFor="message">Leave a message</label>
							<textarea
								id="message"
								name="message"
								value={formData.message}
								onChange={handleChange}
							/>
						</div>
						<button type="submit" className="submitBtn"> Submit </button>
					</form>
				</div>
			</div>
		</>
	);
};

export default ContactUs;